import { render, staticRenderFns } from "./DeleteSectionNotification.vue?vue&type=template&id=726bc75f&scoped=true&"
import script from "./DeleteSectionNotification.vue?vue&type=script&lang=js&"
export * from "./DeleteSectionNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726bc75f",
  null
  
)

export default component.exports